import { useModal } from 'vue-final-modal';

import ModalsAlert from '@/components/modals/Alert.vue';

export const useAlertModal = ({
  title = undefined,
  text = undefined,
  buttonText = undefined,
} = {}) => {
  const alertModal = useModal({
    component: ModalsAlert,
    attrs: {
      title,
      text,
      buttonText,
    },
  });

  function open(patchData = undefined) {
    if (patchData) {
      alertModal.patchOptions({
        attrs: { ...patchData },
      });
    }

    return alertModal.open();
  }

  return { open };
};
